/* Church Sign Shop — Large format estimate form.
   - "Add another item" repeater (item 1 is server-rendered and works without JS)
   - Each item is submitted as ONE readable line in the notification email:
       Item 1: 2 × Foam Board (3/16 in.) — 48" W × 96" H — double sided
   - "Other" material makes the item description required
   - Pickup date: enforces the minimum turnaround, counted in shop days only */
(function () {
  var DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  function init() {
    var root = document.querySelector("[data-lfq]");
    if (!root) return;
    var list = root.querySelector("[data-lfq-items]");
    var addBtn = root.querySelector("[data-lfq-add]");
    if (!list) return; /* success state — no form on the page */

    var maxItems = parseInt(root.getAttribute("data-max-items"), 10) || 6;

    /* ── ITEMS ─────────────────────────────────────────────────── */
    function field(item, key) { return item.querySelector('[data-lfq-f="' + key + '"]'); }

    function summarize(item) {
      var material = field(item, "material").value;
      var w = field(item, "width").value, h = field(item, "height").value;
      var qty = field(item, "qty").value;
      var notes = field(item, "notes").value.replace(/\s*\n+\s*/g, " / ").trim();
      if (!material && !w && !h && !notes) return "";
      return (qty || "?") + " × " + (material || "?") +
             " — " + (w || "?") + '" W × ' + (h || "?") + '" H' +
             (notes ? " — " + notes : "");
    }

    /* JS owns the field names: strip the per-field fallbacks and keep one
       hidden input per item, in place, so the email lists items in order. */
    function adopt(item) {
      item.querySelectorAll("[data-lfq-f]").forEach(function (el) { el.removeAttribute("name"); });
      var out = document.createElement("input");
      out.type = "hidden";
      out.setAttribute("data-lfq-out", "");
      item.appendChild(out);
      item.addEventListener("input", function () { sync(item); });
      item.addEventListener("change", function () { sync(item); });
      field(item, "material").addEventListener("change", function () { syncNotesRequired(item); });
      item.querySelector("[data-lfq-remove]").addEventListener("click", function () {
        item.remove();
        renumber();
      });
    }

    function sync(item) { item.querySelector("[data-lfq-out]").value = summarize(item); }

    function syncNotesRequired(item) {
      var other = /^other/i.test(field(item, "material").value);
      field(item, "notes").required = other;
      var opt = item.querySelector("[data-lfq-notes-opt]");
      if (opt) opt.hidden = other;
    }

    function renumber() {
      var items = list.querySelectorAll("[data-lfq-item]");
      items.forEach(function (item, i) {
        item.querySelector("[data-lfq-item-title]").textContent = "ITEM " + (i + 1);
        item.querySelector("[data-lfq-out]").name = "contact[item_" + (i + 1) + "]";
        item.querySelector("[data-lfq-remove]").hidden = items.length < 2;
      });
      addBtn.hidden = items.length >= maxItems;
    }

    var first = list.querySelector("[data-lfq-item]");
    var blank = first.cloneNode(true); /* pristine copy, taken before adopt() */
    adopt(first);
    sync(first);
    syncNotesRequired(first);

    addBtn.addEventListener("click", function () {
      var item = blank.cloneNode(true);
      list.appendChild(item);
      adopt(item);
      renumber();
      field(item, "material").focus();
    });
    renumber();

    /* ── PICKUP DATE ───────────────────────────────────────────── */
    var dateInput = root.querySelector("[data-lfq-date]");
    if (dateInput) {
      var leadDays = parseInt(root.getAttribute("data-lead-days"), 10) || 0;
      var openDays = (root.getAttribute("data-open-days") || "1,2,3,4").split(",").map(Number);
      var isOpen = function (d) { return openDays.indexOf(d.getDay()) !== -1; };
      var iso = function (d) {
        return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
      };
      var pretty = function (d) {
        return DAY_NAMES[d.getDay()] + ", " + MONTH_NAMES[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
      };

      /* earliest pickup = the Nth shop day after today */
      var earliest = new Date();
      earliest.setHours(0, 0, 0, 0);
      var counted = 0;
      while (counted < leadDays) {
        earliest.setDate(earliest.getDate() + 1);
        if (isOpen(earliest)) counted++;
      }
      while (!isOpen(earliest)) earliest.setDate(earliest.getDate() + 1);
      dateInput.min = iso(earliest);

      /* readable copy for the email ("Wed, Sep 23, 2026") */
      var dateOut = document.createElement("input");
      dateOut.type = "hidden";
      dateOut.name = dateInput.name;
      dateInput.removeAttribute("name");
      dateInput.parentNode.insertBefore(dateOut, dateInput.nextSibling);

      var checkDate = function () {
        var msg = "";
        dateOut.value = "";
        if (dateInput.value) {
          var p = dateInput.value.split("-");
          var d = new Date(+p[0], +p[1] - 1, +p[2]);
          if (d < earliest) msg = "The earliest pickup date is " + pretty(earliest) + ".";
          else if (!isOpen(d)) msg = "Pickup is available " + openDays.map(function (n) { return DAY_NAMES[n]; }).join(", ") + ". Please choose one of those days.";
          else dateOut.value = pretty(d);
        }
        dateInput.setCustomValidity(msg);
      };
      dateInput.addEventListener("input", checkDate);
      dateInput.addEventListener("change", checkDate);
      checkDate();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
